<template>
  <svg width="21" height="22" viewBox="0 0 21 22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.75 15.75H3.375C2.06332 15.75 1 14.6867 1 13.375V3.875C1 2.56332 2.06332 1.5 3.375 1.5H12.875C14.1867 1.5 15.25 2.56332 15.25 3.875V6.25M8.125 20.5H17.625C18.9367 20.5 20 19.4367 20 18.125V8.625C20 7.31332 18.9367 6.25 17.625 6.25H8.125C6.81332 6.25 5.75 7.31332 5.75 8.625V18.125C5.75 19.4367 6.81332 20.5 8.125 20.5Z"
    />
    <path d="M10 13.5L12 15.5L16 11.5" />
  </svg>
</template>
